import Vue from 'vue'
import VueRouter from 'vue-router'
const Myinformation = () => import('../views/information/myinformation.vue')
const heatnumber = () => import('../views/heat/heatnumber.vue')
const popularity = () => import('../views/heat/popularity/ropularity.vue')
const Collection = () => import('../views/heat/Collection/collection.vue')
const Latestupload = () => import('../views/heat/Latestupload/Latestupload.vue')
const Scoresranking = () => import('../views/heat/scoresranking/Scoresranking')
const Informdetails = () => import('../components/Informdetails/Informdetails.vue')
const Rankingpage = () => import('../components/Rankingpage/Rankingpage.vue')
const Sharehomepage = () => import('../components/Sharehomepage/Sharehomepage.vue')
const Newslist = () => import('../views/Newslist/Newslist.vue')
const Personalnav = () => import('../views/Individualmodule/Personalnav.vue')
const Myinfor = () => import('../views/Individualmodule/Myinformation/Myinfor.vue')
const coursedetailspage = () => import('../components/coursedetailspage/coursedetailspage.vue')
const PopularScienceDetails = () => import('../views/HealthPopularization/PopularScienceDetails.vue')
const ArticleDetails = () => import('../views/HealthPopularization/ArticleDetails.vue')

const PopularIntroduction = () => import('../views/HealthPopularization/components/PopularIntroduction.vue')
const DoctorIntroduction = () => import('../views/HealthPopularization/components/DoctorIntroduction.vue')
const PopularReview = () => import('../views/HealthPopularization/components/PopularReview.vue')
const ReviewScore = () => import('../views/HealthPopularization/components/ReviewScore.vue')


const Studentscomment = () => import('../views/description/Studentscomment.vue')
const SoftwareDownloading = () => import('../views/description/SoftwareDownloading.vue')
const Instructionsfor = () => import('../views/description/Instructionsfor.vue')
const coursedescription = () => import('../views/description/coursedescription.vue')
const AboutInstructor = () => import('../views/description/AboutInstructor.vue')
const Myevaluation = () => import('../views/Individualmodule/Myevaluation/Myevaluation.vue')
const Mycollection = () => import('../views/Individualmodule/Mycollection/Mycollection.vue')
const Learningecord = () => import('../views/Individualmodule/Learningecord/Learningecord.vue')
const TeacherDetailsPage = () => import('../components/TeacherDetailsPage.vue')
const Searchpage = () => import('../views/Searchpage/Searchpage.vue')
const aboutus = () => import('../views/Aboutus/aboutus.vue')
const Materialpage = () => import('../views/Materialpage/materialpage.vue')
const materialdetailspage = () => import('../components/Materialdetailspage/materialdetailspage.vue')
const Uploadpagem = () => import('../views/Materialpage/Uploadpagem.vue')
const Materialtoupload = () => import('../views/Individualmodule/Materialoupload/Materialtoupload.vue')
const Home = () => import('../views/Home.vue')
const NotFount = () => import('../components/error/404.vue')
const Courseupload = () => import('../views/information/Courseupload.vue')
const UploadPopular = () => import('../views/HealthPopularization/UploadPopular.vue')

const HealthSciencePopularization = () => import('../views/HealthPopularization/HealthSciencePopularization.vue')
const QualityPapers = () => import('../views/QualityPapers/QualityPapers.vue')


Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },

    {
      path: '/myinformation',
      name: 'myinformation',
      component: Myinformation
    },
    {
      path: '/HealthSciencePopularization',
      name: 'HealthSciencePopularization',
      component: HealthSciencePopularization
    },{
      path: '/QualityPapers',
      name: 'QualityPapers',
      component: QualityPapers
    },
    {
      path: '/Informdetails/:id',
      name: 'Informdetails',
      component: Informdetails
    },
    {
      path: '/Rankingpage',
      name: 'Rankingpage',
      component: Rankingpage
    },
    {
      path: '/Sharehomepage',
      name: 'Sharehomepage',
      component: Sharehomepage
    },
    {
      path: '/Newslist/:id',
      name: 'Newslist',
      component: Newslist
    },
    // 老师详情页
    {
      path: '/TeacherDetailsPage/:id',
      name: 'TeacherDetailsPage',
      component: TeacherDetailsPage
    },
    // 搜索页面
    {
      path: '/Searchpage/:id',
      name: 'Searchpage',
      component: Searchpage
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    // 素材页面
    {
      path: '/Materialpage',
      name: 'Materialpage',
      component: Materialpage
    },
    // 素材详情页
    {
      path: '/materialdetailspage',
      name: 'materialdetailspage',
      component: materialdetailspage
    },
    // 素材上传页
    {
      path: '/Uploadpagem',
      name: 'Uploadpagem',
      component: Uploadpagem
    },
    {
      path: '/Courseupload',
      name: 'Courseupload',
      component: Courseupload
    }, {
      path: '/UploadPopular/:id',
      name: 'UploadPopular',
      component: UploadPopular
    }, {
      path: '/UploadPopular',
      name: 'UploadPopular1',
      component: UploadPopular
    },

    // 热度排行
    {
      path: '/heatnumber',
      name: 'heatnumber',
      component: heatnumber,
      redirect: '/ropularity',
      children: [{
        path: '/ropularity',
        name: 'ropularity',
        component: popularity
      },
      {
        path: '/collection',
        name: 'collection',
        component: Collection
      },
      {
        path: '/latestupload',
        name: 'latestupload',
        component: Latestupload
      },
      {
        path: '/scoresranking',
        name: 'scoresranking',
        component: Scoresranking
      }
      ]
    },
    // 个人信息
    {
      path: '/personalnav',
      name: 'personalnav',
      component: Personalnav,
      redirect: '/Myinfor',
      children: [
        {
          path: '/Myinfor',
          name: 'Myinfor',
          component: Myinfor
        },
        {
          path: '/Myevaluation',
          name: 'Myevaluation',
          component: Myevaluation
        },
        {
          path: '/Mycollection',
          name: 'Mycollection',
          component: Mycollection
        },
        {
          path: '/Learningecord',
          name: 'Learningecord',
          component: Learningecord
        },
        {
          path: '/Materialtoupload',
          name: 'Materialtoupload',
          component: Materialtoupload
        },
        {
          path: '/Courselist',
          name: 'Courselist',
          component: () => import('../views/Individualmodule/Courselist/Courselist.vue')
        },{
          path: '/TaskList',
          name: 'TaskList',
          component: () => import('../views/Individualmodule/TaskList/TaskList.vue')
        },
        {
          path: '/Coursedetails/:id',
          name: 'Coursedetails',
          component: () => import('../views/Individualmodule/Courselist/Coursedetails.vue')
        },
        {
          path: '/KPdetails/:id',
          name: 'KPdetails',
          component: () => import('../views/Individualmodule/Materialoupload/KPdetails.vue')
        }
      ]
    }, {
      path: '/ArticleDetails',
      name: 'ArticleDetails',
      component: ArticleDetails,
    },

    //科普详情页
    {
      path: '/PopularScienceDetails',
      name: 'PopularScienceDetails',
      component: PopularScienceDetails,
      children: [
        {
          path: '/',
          redirect: '/PopularIntroduction'
        },
        {
          path: '/PopularReview',
          name: 'PopularReview',
          component: PopularReview
        },
        {
          path: '/PopularIntroduction',
          name: 'PopularIntroduction',
          component: PopularIntroduction
        },
        // {
        //   path: '/Instructionsfor',
        //   name: 'Instructionsfor',
        //   component: Instructionsfor
        // },
        {
          path: '/DoctorIntroduction',
          name: 'DoctorIntroduction',
          component: DoctorIntroduction
        },
        {
          path: '/ReviewScore',
          name: 'ReviewScore',
          component: ReviewScore
        }

      ]

    },
    // 课程详情页
    {
      path: '/coursedetailspage',
      name: 'coursedetailspage',
      component: coursedetailspage,
      children: [
        {
          path: '/',
          redirect: '/SoftwareDownloading'
        },
        {
          path: '/Studentscomment',
          name: 'Studentscomment',
          component: Studentscomment
        },
        {
          path: '/SoftwareDownloading',
          name: 'SoftwareDownloading',
          component: SoftwareDownloading
        },
        {
          path: '/Instructionsfor',
          name: 'Instructionsfor',
          component: Instructionsfor
        },
        {
          path: '/coursedescription',
          name: 'coursedescription',
          component: coursedescription
        },
        {
          path: '/AboutInstructor',
          name: 'AboutInstructor',
          component: AboutInstructor
        }

      ]

    },
    {
      path: '/*',
      name: '/404',
      component: NotFount
    }
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

  ]
})
//  每次路由跳转侧边导航栏回到顶部
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })
// const routerReplace = VueRouter.prototype.replace
// VueRouter.prototype.replace = function (location) {
//   return routerReplace.call(this, location).catch(error => error)
// }
// router.afterEach((to, from, next) => {
//   document.documentElement.scrollTop = 0
//   document.body.scrollTop = 0
// })
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }
router.afterEach((to, from, next) => {
  console.log(to.path)
  if (to.path !== '/SoftwareDownloading' && to.path !== '/coursedescription' && to.path !== '/AboutInstructor' && to.path !== '/Instructionsfor' && to.path !== '/Studentscomment') {
    window.scrollTo({
      top: 0
    })
  }
})

export default router
